import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt, FaEye } from 'react-icons/fa'

import Modal from '../../../shared/modal/Modal'
import api from '../../../utils/api'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import EditProcedure from '../EditProcedure'
import ProcedureChecklistPreview from '../ProcedureChecklistPreview'
import useFlashMessage from '../../../hooks/useFlashMessage'
import useMyPermission from '../../../hooks/useMyPermission'

function ListProcedureRow({ dataArray, handleOnSuccess, myPermission }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const { checkPermission } = useMyPermission()
    const myPermissionEdit = checkPermission(myPermission, "procedure_Edit")
    const myPermissionDelete = checkPermission(myPermission, "procedure_Delete")

    const [modalEditProcedure, setModalEditProcedure] = useState(false)
    const [procedureId, setProcedureId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [procedureName, setProcedureName] = useState("")
    const [previewProcedure, setPreviewProcedure] = useState(null)

    async function deleteProcedure(id) {
        let msgType = 'success'
        const data = await api.delete(`/procedure/delete/${id}`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            handleOnSuccess()
            setModalDeleteItem(false)
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
    }

    return (
        <div>
            {dataArray && dataArray.map((item) => (
                <div key={item._id} className="pg-item">
                    <div className="pg-item-main">
                        <div className="pg-item-header">
                            <span className="pg-item-name">{item.name}</span>
                            {item.disabled && (
                                <span className="pg-item-status-disabled">Desabilitado</span>
                            )}
                        </div>
                        {item.description && (
                            <div className="pr-item-desc">{item.description}</div>
                        )}
                        <span className="pr-item-count">
                            {(item.items || []).length} {(item.items || []).length === 1 ? 'item no checklist' : 'itens no checklist'}
                        </span>
                    </div>

                    <div className='shd-row-box-item-action'>
                        <FaEye
                            className='shd-icon-row-edit pr-icon-preview'
                            title='Pré-visualizar checklist'
                            onClick={() => setPreviewProcedure(item)}
                        />
                        {myPermissionEdit &&
                            <FaPencilAlt
                                className='shd-icon-row-edit'
                                title='Editar'
                                onClick={() => { setProcedureId(item._id); setModalEditProcedure(true) }}
                            />
                        }
                        {myPermissionDelete &&
                            <FaTrashAlt
                                className='shd-icon-row-trash'
                                title='Apagar'
                                onClick={() => { setModalDeleteItem(true); setProcedureId(item._id); setProcedureName(item.name) }}
                            />
                        }
                    </div>
                </div>
            ))}

            <Modal
                modalStatus={modalEditProcedure}
                changeStatus={setModalEditProcedure}
                w={82}
                content={
                    <EditProcedure
                        id={procedureId}
                        handleOnSuccess={() => { setModalEditProcedure(false); handleOnSuccess() }}
                        btCancelAction={() => setModalEditProcedure(false)}
                    />
                }
            />

            <ProcedureChecklistPreview
                modalStatus={!!previewProcedure}
                changeStatus={() => setPreviewProcedure(null)}
                procedure={previewProcedure}
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteProcedure(procedureId)}
                message="Deseja realmente excluir esse procedimento?"
                itemName={procedureName}
            />
        </div>
    )
}

export default ListProcedureRow
